import React from 'react'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import StyledSVG from '../components/shared/StyledSVG'
import AnnouncementsSVG from '../assets/icons/announcements.svg'
import PhotoSVG from '../assets/icons/photo.svg'
import EventsSVG from '../assets/icons/events.svg'
import moderateSVG from '../assets/icons/moderate.svg'
import archivesSVG from '../assets/icons/archives.svg'
import AnnouncementsView from '../components/view/AnnouncementsView'
import ButtonCard from '../components/card/ButtonCard'
import { roles } from '../utils/constants'

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Montserrat, Source Sans Pro',
    width: '98%',
    padding: '1rem 0'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: 16,
    margin: 16,
    flexWrap: 'wrap',
    [theme.breakpoints.down('426')]: {
      '& button': {
        width: '100px',
        height: '100px',
        '& svg': {
          width: '30px !important',
          height: '30px !important',
          minWidth: '30px !important',
          minHeight: '30px !important'
        },
        '& p': {
          fontSize: '10px'
        }
      }
    },
    [theme.breakpoints.down('330')]: {
      '& button': {
        width: '80px',
        height: '80px'
      }
    }
  },
  paper: {
    borderRadius: 8,
    padding: 32
  }
}))

const defaultColor = '#00ACDB'
// const disabledColor = '#ADB8CC'

const AnnouncementsPage = ({
  userOccupations,
  event_moderation,
  match,
  componentAttribute
}) => {
  const classes = useStyles()
  const history = useHistory()
  const isAdmin =
    userOccupations?.includes(roles.SCHOOL_ADMIN) ||
    userOccupations?.includes(roles.VERSAR_ADMIN)
  const isTeacher = userOccupations?.includes(roles.TEACHER)
  const [eventType, setEventType] = React.useState(
    history.location.state?.event_type ?? 'communications'
  )
  const topButtons = [
    {
      id: 1,
      title: 'Comunicados',
      icon: AnnouncementsSVG,
      type: 'communications'
    },
    {
      id: 2,
      title: 'Fotos',
      icon: PhotoSVG,
      type: 'images'
    },
    {
      id: 3,
      title: 'Eventos',
      icon: EventsSVG,
      type: 'events'
    },
    {
      id: 4,
      title: 'Moderação',
      icon: moderateSVG,
      type: 'review'
    },
    {
      id: 5,
      title: 'Meu mural',
      icon: archivesSVG,
      type: 'selfs'
    }
  ]

  const handleClickButton = type => {
    history.push(`/announcements`, {
      event_type: type
    })
  }

  const getTitleByType = type => {
    switch (type) {
      case 'communications':
        return 'Comunicados'
      case 'images':
        return 'Fotos'
      case 'review':
        return 'Moderação'
      case 'selfs':
        return 'Meu mural'
      case 'events':
        return 'Eventos'
      default:
        break
    }
  }

  React.useEffect(
    () => {
      if (history.location.state?.event_type) {
        setEventType(history.location.state.event_type)
      }
    },
    [history.location.state?.event_type]
  )

  return (
    <div className={classes.root}>
      <div className={classes.buttons}>
        {topButtons
          .filter(btn => {
            const hiddeModeration = !event_moderation
            if (hiddeModeration) {
              return btn.type !== 'review'
            } else {
              return true
            }
          })
          .filter(
            btn =>
              (!isAdmin ? btn.type !== 'review' : btn.type) &&
              (!isTeacher ? btn.type !== 'selfs' : btn.type)
          )
          .map(btn => {
            return (
              <ButtonCard
                key={btn.id}
                styleType={eventType === btn.type ? 'default' : 'disabled'}
                onClick={() => handleClickButton(btn.type)}
              >
                <StyledSVG
                  color={defaultColor}
                  src={btn.icon}
                  width={35}
                  height={35}
                />
                <p>{btn.title}</p>
              </ButtonCard>
            )
          })}
      </div>
      <AnnouncementsView
        componentAttribute={componentAttribute}
        match={match}
        isAdmin={isAdmin}
        eventType={eventType}
        title={() => getTitleByType(eventType)}
      />
    </div>
  )
}

const mapStateToProps = ({ auth, school }) => {
  return {
    userOccupations: auth.currentOccupation,
    event_moderation: school.school_config.event_moderation
  }
}

export default connect(mapStateToProps)(AnnouncementsPage)
